/* eslint-disable */
import { AppBar, Box, Dialog, IconButton, Toolbar, Typography, Slide, Button, Grid, DialogTitle, FormControlLabel, Checkbox, TextField, InputBase } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as BigArrowIcon } from "../../Assets/svg/bigArrowIcon.svg";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as PhoneIcon } from "../../Assets/svg/PhoneIcon.svg";
import { ReactComponent as GreenArrow } from "../../Assets/svg/greenArrow.svg";
import { ReactComponent as BooksIcon } from "../../Assets/svg/BooksIcon.svg";
import ButtonNavigation from '../../Components/ButtonNavigation';
import { ReactComponent as ThreeDotsIcon } from "../../Assets/svg/ThreeDotsIcon.svg";
import { ReactComponent as WhiteLocationIcon } from "../../Assets/svg/WhiteLocationIcon.svg";
import { ReactComponent as PersonCircleIcon } from "../../Assets/svg/PersonCircleIcon.svg";
import { ReactComponent as GrayLocation } from "../../Assets/svg/GrayLocation.svg";
import { ReactComponent as GreenCheckIcon } from "../../Assets/svg/GreenCheckIcon.svg";
import { ReactComponent as FloorIcon } from "../../Assets/svg/FloorIcon.svg";
import { ReactComponent as MobileIcon } from "../../Assets/svg/MobileIcon.svg";
import { ReactComponent as MailIcon } from "../../Assets/svg/MailIcon.svg";
import { ReactComponent as FloorNumIcon } from "../../Assets/svg/FloorNumIcon.svg";
import { ReactComponent as RoomIcon } from "../../Assets/svg/RoomIcon.svg";
import { ReactComponent as ZirbanaIcon } from "../../Assets/svg/ZirbanaIcon.svg";
import { ReactComponent as UsageTypeIcon } from "../../Assets/svg/UsageTypeIcon.svg";
import { ReactComponent as MasahatIcon } from "../../Assets/svg/MasahatIcon.svg";
import { ReactComponent as GreenDotIcon } from "../../Assets/svg/GreenDotIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as PlusIcon } from "../../Assets/svg/PlusIcon.svg";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
import { ReactComponent as LabelsIcon } from "../../Assets/svg/LabelsIcon.svg";
import { ReactComponent as HouseIcon } from "../../Assets/svg/HouseIcon.svg";
import { ReactComponent as ShareIcon } from "../../Assets/svg/ShareIcon.svg";
import { ReactComponent as SendIcon } from "../../Assets/svg/SendIcon.svg";
import { ReactComponent as PenIcon } from "../../Assets/svg/PenIcon.svg";
import { ReactComponent as BackUpIcon } from "../../Assets/svg/BackUpIcon.svg";
import { ReactComponent as DelIcon } from "../../Assets/svg/DelIcon.svg";
import { ReactComponent as RoundArrowsIcon } from "../../Assets/svg/RoundArrowsIcon.svg";
import { ReactComponent as SettingDarkGray } from "../../Assets/svg/SettingDarkGray.svg";
import { ReactComponent as PlusGreenIcon } from "../../Assets/svg/PlusGreenIcon.svg";
import { ReactComponent as CheckIcon } from "../../Assets/svg/CheckIcon.svg";
import Snackbar from '@mui/material/Snackbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useParams } from "react-router-dom";
// Import Swiper styles
import 'swiper/css';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import moment from "moment-jalaali"
import { useUserStore } from '../../store/user';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
import { useSnackbar } from 'notistack';
import { TileLayer, Marker, Popup, MapContainer } from 'react-leaflet'
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import { useSearchPropStore } from '../../store/searchProperty';
import PropertyContactModal from "../../Components/PropertyContactModal";
import { CheckPermissions } from "../../Components/CheckPermissions";
import ModalComponent from "../../Components/ModalComponent";
import { newShade, lightOrDark, getUserToken, getToken } from "../../Components/PublicFunctions";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../../Components/persian-mobile-datepicker-config'
import Cookies from 'js-cookie'
import ShareModalCompo from "../../Components/ShareModal";
import SetLabelsModal from "../../Components/SetLabelsModal";
import RelationsModal from "../../Components/RelationsModal";
import LabelsList from "./LabelsList";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

function LocationMarker(props) {



    return props.position === null ? "" : (
        <Marker position={props.position}>
            <Popup> </Popup>
        </Marker>
    )
}

function PropertyDetails(props) {

    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }

    const { enqueueSnackbar } = useSnackbar();

    let { search } = useLocation();
    const showMore = useMemo(() => new URLSearchParams(search), [search]).get("showMore");


    console.log("🚀 ~ PropertyDetails ~ showMore:", showMore)


    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const setUserInfo = useUserStore((state) => state.setUserInfo)

    const propFacilities = useUserStore((state) => state.propFacilities)
    const locationId = useUserStore((state) => state.locationId)

    const [ContactModal, setContactModal] = useState(false);

    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [propInfo, setPropInfo] = useState({})
    const [propInfoLoading, setPropInfoLoading] = useState(false)
    const [openMapModal, setOpenMapModal] = useState(false)
    const [openBuyFileModal, setOpenBuyFileModal] = useState(false)
    const [buyLoading, setBuyLoading] = useState(false)
    const [archiveDeleteModal, setArchiveDeleteModal] = useState(false)
    const [archiveDeleteLoading, setAarchiveDeleteLoading] = useState(false)
    const [archiveDeleteId, setArchiveDeleteId] = useState("")
    const [archives, setArchives] = useState([])
    const [editArchiveModal, seteditArchiveModal] = useState(false);
    const [HasRentReminder, setHasRentReminder] = useState(0)

    const [commissionPrice, setCommissionPrice] = useState(null);
    const [showCommissionPrice, setShowCommissionPrice] = useState("");
    const [ContractCancelled, setContractCancelled] = useState(0)
    const [commissionUsers, setCommissionUsers] = useState([
        { AgencyId: "", Price: "", Name: "" }
    ]);
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [RentReminderDate, setRentReminderDate] = useState("")
    const [indexUserSelected, setIndexUserSelected] = useState(null)
    const [commissionUsersLoading, setCommissionUsersLoading] = useState(false)
    const [archiveSelectedId, setArchiveSelectedId] = useState(false)

    const [archiveModal, setArchiveModal] = useState(false);

    const [tmpIsBought, setTmpIsBought] = useState(false);

    const [openMoreOptionsModal, setOpenMoreOptionsModal] = useState(false)
    const [openLabelsModal, setOpenLabelsModal] = useState(false)

    const propertySelected = useSearchPropStore((state) => state.propertySelected)
    const setPropertySelected = useSearchPropStore((state) => state.setPropertySelected)

    const [uploadImagesLoading, setUploadImagesLoading] = useState(false);

    const [isLabelOn, setIsLabelOn] = React.useState(false);
    const [labels, setLabels] = useState([]);
    const [labelsDetails, setLabelsDetails] = useState([]);
    const [labelsLoading, setLabelsLoading] = useState(false);
    const [labelsChecked, setLabelsChecked] = useState({})
    const [labelIndexForUser, setLabelIndexForUser] = useState("")

    const [showShareModal, setShowShareModal] = useState(false)


    const [relationsModal, setRelationModal] = useState(false);

    const [relations, setRelations] = useState([]);
    const [relationsLoading, setRelationsLoading] = useState(false);

    const handleRelationsModalOpen = () => {
        setRelationModal(true);
    };
    const handleRelationsModalClose = () => {
        setRelationModal(false);
    };

    const handleShareModalOpen = (id) => {
        setShowShareModal(true);
    };
    const handleShareModalClose = () => {
        setShowShareModal(false);
    };

    const handleGetLabels = async () => {
        console.log("labels")
        setLabelsLoading(true)
        try {
            const response = await http({
                url: "/webapp/entities/labels",
                method: "POST",
                data: {
                    "EntityId": propInfo?.Id,
                    "EntityType": 1
                },
                headers: {
                    "Authorization": `Bearer ${getToken()}`
                }
            })
            console.log("🚀 ~ handleGetLabels ~ response:", response)
            setLabelsDetails(response?.data?.result?.result)

        } catch (e) {
            console.error(e);

        }
        setLabelsLoading(false)

    }


    const handleGetRelations = async () => {
        setRelationsLoading(true)
        try {
            const response = await http({
                url: "/properties/connections",
                method: "POST",
                data: {
                    "PropertyId": propInfo?.Id,
                },
                headers: {
                    "Authorization": `Bearer ${getToken()}`
                }
            })
            console.log("🚀 ~ handleGetRelations ~ response:", response)
            // setRelations(response?.data?.result?.result)

        } catch (e) {
            console.error(e);

        }
        setRelationsLoading(false)

    }


    const dataFetchedRef = useRef(false);

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        if (showMore)
            handleMoreOptionsModalClick()




    }, [])

    useEffect(() => {
        if (Object.keys(propInfo).length) {
            if (localStorage.getItem("searchHistory")) {
                var tmp = JSON.parse(localStorage.getItem('searchHistory'))
                if (!tmp[propInfo.Id]) {
                    tmp[propInfo.Id] = {
                        "title": `${propInfo.ForSale ? `فروش ` : ""}
                        ${propInfo.ForRent ? `اجاره ` : ""}
                        ${propInfo.ForPresale ? `پیش فروش ` : ""}
                        ${propInfo.ForExchange ? `معاوضه ` : ""}
                        ${propInfo.ForAssociate ? `مشارکت ` : ""} 
                        ${propInfo?.PropertyType ? `در ${propInfo?.PropertyType}` : ""}  
                        ${propInfo.PropertyArea ? propInfo.PropertyArea : ""}`,
                        "type": "property"
                    }
                }
            } else {
                var tmp = {}
                tmp[propInfo.Id] = {
                    "title": `${propInfo.ForSale ? `فروش ` : ""}${propInfo.ForRent ? `اجاره ` : ""}${propInfo.ForPresale ? `پیش فروش ` : ""}${propInfo.ForExchange ? `معاوضه ` : ""}${propInfo.ForAssociate ? `مشارکت ` : ""} ${propInfo?.PropertyType} در ${propInfo.PropertyArea}`,
                    "type": "property"
                }
            }
            localStorage.setItem("searchHistory", JSON.stringify(tmp))

            handleGetLabels()
            handleGetRelations()
        }


    }, [propInfo])


    const handleSetUserLabel = (user) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("labelIndexForUser", labelIndexForUser)
        labelsCheckedTmp[labelIndexForUser].AssignedUser = user.id
        labelsCheckedTmp[labelIndexForUser].AgencyName = user.username
        setLabelsChecked(labelsCheckedTmp)

        handleOpenUsersModalClose()
    }

    const handleNavigateToSettingLabels = () => {
        navigate("/settings", { state: { showLabel: true } });

    }

    const closePickerHandle = (index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index][`showPicker${index}`] = false
        setLabelsChecked(labelsCheckedTmp)
    }

    const showPickerHandle = (index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index][`showPicker${index}`] = true
        setLabelsChecked(labelsCheckedTmp)
    }

    const handleSetRepeatDays = (e, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index]['RepeatDays'] = e.target.value
        console.log("e.target.value", e.target.value)
        setLabelsChecked(labelsCheckedTmp)
    }


    const LabelReminderDateHandle = (selectedDate, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("index", index)
        labelsCheckedTmp[index].RemindDate = +selectedDate.date
        setLabelsChecked(labelsCheckedTmp)

    }

    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }

    const handleArchiveModal = () => {
        setArchiveModal(true);
    };
    const handleArchiveModalClose = () => {
        setArchiveModal(false);
    };

    const handleMoreOptionsModalClick = () => {
        setOpenMoreOptionsModal(true);
    };
    const handleMoreOptionsModalClose = () => {
        setOpenMoreOptionsModal(false);
    };

    const handleAddEntityLabel = (id) => {
        document.getElementById(`label-${id}`).classList.toggle("label-selected")

        let labelsCheckedTmp = { ...labelsChecked }

        if (id in labelsCheckedTmp)
            delete labelsCheckedTmp[id]
        else {
            labelsCheckedTmp[id] = { RemindDate: +(new Date()) }
            labelsCheckedTmp[id][`showPicker${id}`] = false
            labelsCheckedTmp[id].id = id
        }

        setLabelsChecked(labelsCheckedTmp)
    }

    useEffect(() => {
        console.log("labelsChecked", labelsChecked)

    }, [labelsChecked])

    const handleLabelsModalClick = async () => {
        setOpenLabelsModal(true);
        setIsLabelOn(true)
        setLabelsLoading(true)
        try {
            const response = await http({
                url: "/webapp/labels",
                method: "POST",
                data: {
                    "Type": 1
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log(response)
            if (response.data.result.result) setLabels(response.data.result.result)
        } catch (e) {
            console.error(e);
        }

        // try {
        //     const response2 = await http({
        //         url: "/webapp/entities/labels",
        //         method: "POST",
        //         data: {
        //             "EntityId": propInfo.Id,
        //             "EntityType": 1
        //         },
        //         headers: {
        //             "Authorization": `Bearer ${Cookies.get('token')}`
        //         }
        //     })
        //     console.log("/entities/labels", response2)
        //     if (response2.data.result.result) {
        //         let tmpLabelsChecked = {}
        //         response2.data.result.result.map(item => {
        //             tmpLabelsChecked[item.LabelId] = {}
        //             tmpLabelsChecked[item.LabelId][`showPicker${item.LabelId}`] = false
        //             tmpLabelsChecked[item.LabelId]["id"] = item.LabelId
        //             tmpLabelsChecked[item.LabelId]["AgencyName"] = item.FullName
        //             tmpLabelsChecked[item.LabelId]["AssignedUser"] = item.AssignedUser
        //             tmpLabelsChecked[item.LabelId]["DailyReminder"] = +item.DailyReminder
        //             tmpLabelsChecked[item.LabelId]["RemindDate"] = +item.RemindDate
        //             tmpLabelsChecked[item.LabelId]["RepeatDays"] = item.RepeatDays
        //         })

        //         setLabelsChecked(tmpLabelsChecked)

        //     }
        // } catch (e) {
        //     console.error(e);
        // }

        // setLabelsLoading(false)

    };
    const handleLabelsModalClose = () => {
        setIsLabelOn(false)
        setOpenLabelsModal(false);
        setLabelsChecked({})
    };

    useEffect(() => {
        setShowCommissionPrice(wordifyfa(commissionPrice))


    }, [commissionPrice])

    const handleSetCommissionPrice = (e, index) => {
        let tmp = [...commissionUsers]
        tmp[index].Price = e.target.value
        setCommissionUsers(tmp)
        console.log("users", commissionUsers)
    }

    const handlePlusUser = () => {
        let tmp = [...commissionUsers]
        tmp.push({ AgencyId: "", Price: "", Name: "" })
        setCommissionUsers(tmp)
    }
    const handleCommisDate = (date, format = 'YYYY/MM/DD') => {
        let object = { date, format }
        let time = new DateObject(object).toUnix()
        setRentReminderDate(time.toString())
        console.log("date", time)
    }
    const handleSetCommissionUsers = () => {
        setCommissionUsersLoading(true)
        let commissionUsersTmp = [...commissionUsers]
        commissionUsersTmp.map(item => {
            item = delete item.Name
        })

        try {
            http({
                // url of the api endpoint (can be changed)
                url: `/properties/${propInfo.Id}/archive/update`,
                method: "POST",
                data: {
                    "Id": archiveSelectedId,
                    "TotalPrice": commissionPrice,
                    "ContractCancelled": ContractCancelled,
                    "HasRentReminder": HasRentReminder,
                    "RentReminderDate": RentReminderDate,
                    "Users": commissionUsersTmp
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res)
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar('بایگانی شما با موفقیت ویرایش شد.', { variant });

                    const archiveTmp = [...archives]
                    archiveTmp.map((item, index) => {
                        if (item.Id == archiveSelectedId)
                            archiveTmp[index] = res.data.result
                    })
                    setArchives(archiveTmp)
                    handleeditArchiveModalClose()
                }
                setCommissionUsersLoading(false)
            });

        } catch (e) {
            console.error(e);
            setCommissionUsersLoading(false)
        }
    }
    //user modal
    const handleClickOpenUsersModal = (index = null, label = null) => {
        if (index || index == 0) {
            console.log("index", index)
            setIndexUserSelected(index)

        }
        if (label || label == 0) {
            setLabelIndexForUser(label)
            console.log("label", label)
        }
        getUsers(true)
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };
    // const handleClickOpenUsersModal = (index) => {
    //     console.log("index",index)
    //     setIndexUserSelected(index)
    //     getUsers(true)
    //     setTimeout(function () {
    //         if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
    //             console.log("Users Use")
    //             document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
    //             return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
    //         }
    //     }, 500)
    //     setOpenUsersModal(true);
    // };
    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };

    const [Users, setUsers] = React.useState([]);
    const [UserOffset, setUserOffset] = React.useState(1);
    const [HasMoreUsers, setHasMoreUsers] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [inPlusingUser, setinPlusingUser] = React.useState(true);
    const [propKey, setPropKey] = React.useState(0);


    const getUsers = (resetState = false) => {
        if (resetState) {
            setUsers([])
            console.log("reset", Users)
            setPropKey(propKey => propKey++)
            setUserOffset(0);
            setHasMoreUsers(true)
        }

        setUsersLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/users/get-my-users",
                method: "GET",
                // data: {
                //     "Limit": 10,
                //     "Offset": UserOffset
                // },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("users", res.data.result.Users);

                const tmpProp = [...Users]
                if (res.data.result.Users.length > 0) {
                    if (!resetState) {
                        res.data.result.Users.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setUsers(tmpProp)

                        setPropKey(propKey => propKey++)
                    }
                    else
                        setUsers(res.data.result.Users)


                    setPropKey(propKey => propKey++)

                } else {
                    console.log("End")
                    setHasMoreUsers(false)
                    if (resetState) setUsers([])

                }

                console.log("users ff", Users)
                setUsersLoading(false)
                setTimeout(function () { setinPlusingUser(true) }, 1000)
            });

        } catch (e) {
            console.error(e);
            setUsersLoading(false)

        }


    }


    const onUsersScroll = () => {
        if (document.getElementById("users-content")) {

            const scrollTop = document.getElementById("users-content").scrollTop
            const scrollHeight = document.getElementById("users-content").scrollHeight
            const clientHeight = document.getElementById("users-content").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && inPlusingUser) {
                setUserOffset(UserOffset => UserOffset + 1);
                // setSearchData({"name":"Offset","value":UserOffset})
                console.log("UserOffset", UserOffset)
                setinPlusingUser(false)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)

        setPropertySelected(id)


    }, [Users])

    console.log("propertySelected", propertySelected)

    useEffect(() => {
        console.log("offset use")

        if (HasMoreUsers && Users.length) {
            getUsers()
        }
    }, [UserOffset])




    // const handleSetUserArchive = (user) => {
    //     let tmp = [...commissionUsers]
    //     console.log("indexUserSelected",indexUserSelected)
    //     tmp[indexUserSelected].Name = user.FullName
    //     tmp[indexUserSelected].AgencyId = user.Id
    //     tmp[indexUserSelected].Id = user.Id
    //     console.log("users", commissionUsers)
    //     handleOpenUsersModalClose()
    // }
    const handleSetUserArchive = (user) => {
        let tmp = [...commissionUsers]
        tmp[indexUserSelected].Name = user.username
        tmp[indexUserSelected].AgencyId = user.id
        console.log("users", commissionUsers)
        handleOpenUsersModalClose()
    }



    ///////////////////////////////

    const handleOpenMapModalClick = () => {
        setOpenMapModal(true);
    };
    const handleOpenMapModalClose = () => {
        setOpenMapModal(false);
    };

    const handleOpenBuyFileModalClick = () => {
        setOpenBuyFileModal(true);
    };
    const handleOpenBuyFileModalClose = () => {
        setOpenBuyFileModal(false);
    };

    const handleArchiveDeleteModalClick = (id) => {
        setArchiveDeleteId(id)
        setArchiveDeleteModal(true);
    };
    const handleArchiveDeleteModalClose = () => {
        setArchiveDeleteModal(false);
    };

    const handleOpenContactModal = () => {
        setContactModal(true);
    };
    const handleContactModalClose = () => {
        setContactModal(false);
    };

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };

    const handleeditArchiveModal = (id) => {
        const archiveSelected = archives.filter(item => item.Id == id)
        console.log("archiveSelected", archiveSelected[0])
        setCommissionPrice(archiveSelected[0].TotalPrice)
        setContractCancelled(archiveSelected[0].ContractCancelled)
        setHasRentReminder(archiveSelected[0].HasRentReminder)
        setRentReminderDate(archiveSelected[0].RentReminderDate)
        setArchiveSelectedId(id)

        let usersTmp = []
        if (archiveSelected[0].Users && archiveSelected[0].Users.length) {
            archiveSelected[0].Users.map(item => {
                usersTmp.push({ AgencyId: item.AgencyId, Price: item.Price, Name: item.FullName })
            })
        }
        setCommissionUsers(usersTmp)
        console.log("CommissionUsers", commissionUsers)
        seteditArchiveModal(true);
    };
    const handleeditArchiveModalClose = () => {
        seteditArchiveModal(false);
    };

    const { id } = useParams();
    useEffect(() => {

        console.log("id", id)
        console.log("userInfo", userInfo)
        console.log("propInfo", propInfo)



        handleToggleBackdrop()

        if (locationId && locationId != "") {
            setPropInfoLoading(true)
            try {
                http({
                    // url of the api endpoint (can be changed)
                    url: "/properties/get/list/by/filter",
                    method: "POST",
                    data: {
                        // "LocationId": locationId,
                        //     "AgencyId": userInfo.Id,
                        "LocationId": locationId,
                        "Ids": [id],
                        "AgencyInfo": true,
                        "LandLordInfo": true
                    },
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    }
                }).then((res) => {
                    console.log("propres", res.data.result.Properties);
                    setPropInfo(res.data.result.Properties[0])
                    setPropInfoLoading(false)
                });

            } catch (e) {
                console.error(e);
                setPropInfoLoading(false)
            }
        } else {
            setPropInfo({})
        }

        try {
            http({
                // url of the api endpoint (can be changed)
                url: `/properties/${propInfo.Id}/archives`,
                method: "POST",
                data: {
                    "AgencyInfo": true,
                    "LandLordInfo": true
                },
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            }).then((res) => {
                // console.log("archives", res.data);
                setArchives(res.data.result)
                console.log("archives", archives)
                handleCloseBackdrop()
            });

        } catch (e) {
            console.error(e);
            handleCloseBackdrop()
        }





    }, [locationId])

    const handleUploadImagesLoadingClose = () => {
        setUploadImagesLoading(false)
    }

    const handleUpdateProp = async (uploudedPic, newPropInfo) => {
        const temp = { ...newPropInfo }
        temp.Pictures = uploudedPic
        temp.ImageCount = uploudedPic.length
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/properties/${temp.Id}`,
                method: "POST",
                data: temp,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res.data.result)
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("عکس ها با موفقیت بارگذاری شدند.", { variant });
                    setUploadImagesLoading(false)
                } else {
                    setUploadImagesLoading(true)
                    const variant = 'error'
                    enqueueSnackbar("بارگذاری تصاویر با مشکل مواجه شد.", { variant });
                }

            });
        } catch (e) {
            console.error(e);
            setUploadImagesLoading(false)

        }
    }

    const uploadImages = async (pics, newPropInfo) => {
        setUploadImagesLoading(true)

        console.log("pics", pics)
        console.log("newPropInfo", newPropInfo)
        var uploudedPic = []
        for (const item of pics) {
            let formData = new FormData();
            formData.append("Prefix", JSON.parse(Cookies.get('agency')).Id)
            formData.append("Link", `https://ws.iranamlaak.net/upload/property/00000000-0000-0000-0000-000000000000/${propInfo.Id}/${item}`,)
            formData.append("Token", "075bdf37-4038-495c-a9b9-85a0826ffa62")
            formData.append("AppType", "Website")
            try {
                const res = await http({
                    // url of the api endpoint (can be changed)
                    url: "/upload-via-link.php",
                    method: "POST",
                    data: formData
                })
                console.log("res", res)
                if (res.data.Name)
                    uploudedPic.push(res.data.Name)


                // if (index >= pics.length)
                //     console.log("index",index)
            } catch (e) {
                console.error(e);
            }
        }

        console.log("uploudedPic", uploudedPic)
        if (uploudedPic.length) {
            handleUpdateProp(uploudedPic, newPropInfo)
        } else {
            const variant = 'error'
            enqueueSnackbar("بارکذاری عکس ها با مشکل مواجه شد.", { variant });
            setUploadImagesLoading(false)
        }
    }


    const saveThisProperty = async (prop) => {

        handleToggleBackdrop()
        let newPropInfo = {}

        console.log("prop[0]", prop[0])
        newPropInfo = { ...prop[0] }

        newPropInfo.Row = +userInfo.LastPropertyRow + 1
        newPropInfo.AgencyId = Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id
        newPropInfo.RegistrarDevice = 8
        newPropInfo.IsConfirmed = "1"
        newPropInfo.Prefix = Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id
        newPropInfo.LocationId = parseInt(newPropInfo.LocationId)

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/properties/new/professional",
                method: "POST",
                data: newPropInfo,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res.data.result)
                if (res.data.result != false) {
                    const variant = 'success'
                    enqueueSnackbar("ملک شما با موفقیت ثبت شد.", { variant });
                    const userTmp = { ...userInfo }
                    userTmp.LastPropertyRow = +userTmp.LastPropertyRow + 1
                    setUserInfo(userTmp)
                    handleOpenBuyFileModalClose()
                    newPropInfo.Id = res.data.result[0].PropertyId
                    console.log("newPropInfo", newPropInfo)



                    uploadImages(propInfo.Pictures, newPropInfo)
                }
                handleCloseBackdrop()
            });
        } catch (e) {
            console.error(e);

            handleCloseBackdrop()
        }
    }

    const handleBuyFile = () => {
        console.log("credit", userInfo.Credit)
        console.log("FilePrice", propInfo.FilePrice)

        if (userInfo.Credit >= propInfo.FilePrice) {
            setBuyLoading(true)
            console.log("buyLoading", buyLoading)
            try {
                http({
                    url: "/divar/agency-has-token",
                    method: "POST",
                    data: {
                        "AgencyId": userInfo.Id,
                    }
                    ,
                    // headers: {
                    //     "Authorization": `Bearer ${accessToken}`
                    // }
                }).then((res) => {
                    // console.log("checkout_url", res.result.checkout_url)

                    if (res.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    } else if (res.data.result.Has) {
                        try {
                            http({
                                url: "/wallet/file/buy",
                                method: "POST",
                                data: {
                                    "Properties": [propInfo.Id],
                                    "LocationId": locationId
                                },
                                headers: {
                                    "Authorization": `Bearer ${accessToken}`
                                }
                            }).then((res) => {
                                // console.log("checkout_url", res.result.checkout_url)

                                if (res.data.result == false) {
                                    const variant = 'error'
                                    enqueueSnackbar(res.data.message, { variant });
                                } else {
                                    const variant = 'success'
                                    enqueueSnackbar("فایل با موفقیت خریداری شد.", { variant });


                                    setTmpIsBought(true)
                                    saveThisProperty(res.data.result.Properties)
                                }

                                setBuyLoading(false)
                            });

                        } catch (e) {
                            console.error(e);
                            if (e.result.data.result == false) {
                                const variant = 'error'
                                enqueueSnackbar(e.response.data.message, { variant });
                            }
                            setBuyLoading(false)
                        }
                    } else {
                        handleMobileModal()
                    }
                });
            } catch (e) {
                console.error(e);
                if (e.result.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
            }
        } else {
            const variant = 'error'
            enqueueSnackbar("کیف پول خود را شارژ کنید.", { variant });
            navigate("/settings")
            setBuyLoading(false)
        }
    }


    const handleDeleteArchive = () => {
        setAarchiveDeleteLoading(true)
        try {
            http({
                url: `/properties/${propInfo.Id}/archive/delete`,
                method: "POST",
                data: {
                    "Id": archiveDeleteId
                },
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            }).then((res) => {
                console.log("archive/delete", res)

                if (res.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(res.data.message, { variant });
                } else {
                    const variant = 'success'
                    enqueueSnackbar("بایگانی با موفقیت حذف شد", { variant });
                    let archiveTmp = [...archives]
                    archiveTmp = archiveTmp.filter(item => item.Id != archiveDeleteId)
                    console.log("archiveTmp", archiveTmp)
                    console.log("archiveDeleteId", archiveDeleteId)

                    setArchives(archiveTmp)
                }
                handleArchiveDeleteModalClose()
                setAarchiveDeleteLoading(false)
                setArchiveDeleteId("")

            });

        } catch (e) {
            console.error(e);
            if (e.result.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            handleArchiveDeleteModalClose()

            setAarchiveDeleteLoading(false)

        }
    }

    const handleDelete = async () => {
        setDeleteLading(true)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/properties/delete/${propInfo.Id}`,
                method: "POST",
                data: {
                    "LocationId": locationId
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("ملک شما با موفقیت حذف شد.", { variant });
                    // props.handleDeletedProps(propInfo.Id)

                }

                handleDeletePropModalClose()
                handleMoreOptionsModalClose()
                setDeleteLading(false)
                goBack()


            });
        } catch (e) {
            console.error(e);

            handleCloseBackdrop()
        }
    }
    const [deletePropModal, setDeletePropModal] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);

    const handleClickOpenDeletePropModal = (id) => {
        setDeletePropModal(true);
    };
    const handleDeletePropModalClose = () => {
        setDeletePropModal(false);
    };

    const priceProp = () => {
        if (propInfo.ForSale)
            return `${propInfo.SalePrice.toLocaleString()} تومان`

        if (propInfo.ForRent)
            return `${propInfo.RentPrice1.toLocaleString()} تومان`

        if (propInfo.ForPresale)
            return `${propInfo.PreSalePrice.toLocaleString()} تومان`

        if (propInfo.ForAssociate)
            return "-"

        if (propInfo.ForExchange)
            return "-"
    }

    const calcMeterPrice = () => {

        if (propInfo.SalePriceCalcMode == 1 && propInfo.Infrastructure)
            return `${parseInt(propInfo.SalePrice / propInfo.Infrastructure).toLocaleString()} تومان`

        else if (propInfo.SalePriceCalcMode == 2 && propInfo.Space)
            return `${parseInt(propInfo.SalePrice / propInfo.Space).toLocaleString()} تومان`
        else if (propInfo.Infrastructure && propInfo.SalePrice)
            return `${parseInt(propInfo.SalePrice / propInfo.Infrastructure).toLocaleString()} تومان`

        else "-"
    }

    return (
        <Box>
            {propInfo ? <Box>
                <Backdrop
                    sx={{ color: '#fff', zIndex: 99999 }}
                    open={openBackdrop}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Box>
                    <Box className="gray-box rounded-20-bottom" sx={{ px: '20px', py: '10px', display: "flex", justifyContent: "space-between", alignItems: 'center', position: 'relative' }}>
                        <IconButton onClick={goBack}>
                            <BigArrowIcon />
                        </IconButton>
                        <Box sx={{ display: 'flex', gap: '0px' }}>
                            {/* <IconButton sx={{ width: '32px', height: '32px' }}>
                                <GreenArrow className="rotate-180-minus" />
                            </IconButton>
                            <IconButton sx={{ width: '32px', height: '32px' }} >
                                <GreenArrow />
                            </IconButton> */}
                        </Box>
                        {propInfo.IsArchived ?
                            <Box sx={{ position: 'absolute', display: 'flex', alignItems: 'center', gap: '5px', left: "17%" }}>
                                <BooksIcon />
                                <Typography component="span" sx={{ fontSize: '11px' }}>
                                    بایگانی شده
                                </Typography>
                            </Box>
                            : !propInfo.IsBought && !tmpIsBought ? userInfo.Id != propInfo.RegistrarAgency && <Button onClick={handleOpenBuyFileModalClick} sx={{ position: 'absolute', display: 'flex', alignItems: 'center', gap: '5px', left: "17%" }}>

                                <Typography component="span" sx={{ fontSize: '11px', color: "#29A19C" }}>
                                    خرید فایل ({propInfo.FilePrice} تومان)
                                </Typography>
                            </Button> : null}
                        <Box>
                            {propInfo.Agency ? <IconButton sx={{ bgcolor: '#D6ECD2!important' }} onClick={handleOpenContactModal}>
                                <PhoneIcon />
                            </IconButton> : null}
                        </Box>
                    </Box>
                    {propInfo && Object.keys(propInfo).length > 0 > 0 ? <Box id="dashboard-content" sx={{ p: 1 }}>
                        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                            <IconButton onClick={handleMoreOptionsModalClick}>
                                <ThreeDotsIcon />
                            </IconButton>

                            <Box>
                                {propInfo.ForSale ? `فروش` : ''}
                                {propInfo.ForRent ? `اجاره` : ''}
                                {propInfo.ForPresale ? `پیش فروش` : ''}
                                {propInfo.ForExchange ? `معاوضه` : ''}
                                {propInfo.ForAssociate ? `مشارکت` : ''} {propInfo.PropertyType}</Box>

                            <Box>{moment.unix(propInfo.RegisterDate).format("jYYYY/jMM/jDD")}</Box>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                            {propInfo.Latitude && propInfo.Latitude != "0" && propInfo.Longitude && propInfo.Longitude != "0" && <IconButton className="rounded-50" sx={{ fontSize: "11px", bgcolor: '#29A19C!important', color: '#fff', display: 'flex', gap: '5px' }} onClick={handleOpenMapModalClick}>
                                <WhiteLocationIcon />
                                مشاهده روی نقشه
                            </IconButton>}
                            <Box>
                                <Typography component="span" sx={{ fontSize: '11px' }}>کد ملک : </Typography>
                                <Typography component="span" sx={{ fontSize: '11px' }}>{propInfo.Row}</Typography>
                            </Box>
                        </Box>
                        <Box sx={{ mt: 1 }}>
                            {propInfo && propInfo.Pictures && propInfo.Pictures.length > 0 ?
                                <Swiper
                                    spaceBetween={50}
                                    slidesPerView={1}
                                    onSlideChange={() => console.log('slide change')}
                                    onSwiper={(swiper) => console.log(swiper)}
                                >
                                    {
                                        propInfo.Pictures.map((item, index) => {
                                            return <SwiperSlide key={index}>
                                                <img src={`https://ws.iranamlaak.net/upload/property/${propInfo.RegistrarAgency}/${propInfo.Id}/${item}`} className="prop-details-img" />
                                            </SwiperSlide>
                                        })
                                    }
                                </Swiper>
                                :
                                null
                            }
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                            <Box sx={{ display: "flex", alignItems: 'center', gap: '5px' }}>
                                <PersonCircleIcon />
                                <Typography component='span' sx={{ fontSize: '11px' }}>ثبت کننده :</Typography>
                                <Typography component='span' sx={{ fontSize: '11px' }}>{propInfo.RegistrarUserName}</Typography>
                            </Box>
                            <Box>
                                <Typography component='span' sx={{ fontSize: '11px' }}>آخرین ویریش</Typography>
                                <Typography component='span' sx={{ fontSize: '11px' }}>{moment.unix(propInfo.RegisterDate).format("jYYYY/jMM/jDD")}</Typography>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', p: 2, mt: 2 }}>
                            <Stack
                                direction="row"
                                divider={<Divider orientation="vertical" flexItem />}
                                spacing={1}
                                sx={{ fontSize: '11px' }}
                            >
                                <Box sx={{ pl: 1 }}>{propInfo.PropertyType}</Box>

                                {
                                    propInfo.UsageType && propInfo.UsageType.map((item, index) => {
                                        return <Box key={index}>{item}</Box>
                                    })

                                }

                            </Stack>
                            <Grid container sx={{ mt: 2 }} spacing={1}>
                                <Grid item xs={6}>
                                    <Typography component='span' sx={{ fontSize: '12px' }}>قیمت : </Typography>
                                    <Typography component='span' sx={{ fontSize: '12px' }}>
                                        {priceProp()}
                                    </Typography>
                                </Grid>
                                {/* {propInfo.LoanPrice ? <Grid item xs={6}>
                                    <Typography component='span' sx={{ fontSize: '12px' }}>قیمت هر قسط : </Typography>
                                    <Typography component='span' sx={{ fontSize: '12px' }}>4,500,000 تومان</Typography>
                                </Grid> : ""} */}
                                {propInfo.LoanPrice ?
                                    <Grid item xs={6}>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>قیمت وام : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo?.LoanPrice.toLocaleString()} تومان</Typography>
                                    </Grid> : ""}
                                {propInfo.ForSale == 1 ? <Grid item xs={6}>
                                    <Typography component='span' sx={{ fontSize: '12px' }}>قیمت هر متر مربع : </Typography>
                                    <Typography component='span' sx={{ fontSize: '12px' }}>{calcMeterPrice()}</Typography>
                                </Grid> : ""}
                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    <GrayLocation />
                                    <Typography component='span' sx={{ fontSize: '12px' }}>
                                        {propInfo.PhysicalAddress ? propInfo.PhysicalAddress : `${propInfo.LocationName ? propInfo.LocationName : ''}. ${propInfo.PropertyAge}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', fontSize: '12px', mt: 2 }}>
                                {
                                    propInfo.Parking == 1 ?
                                        <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}><GreenCheckIcon /> پارکینگ</Box> : ''
                                }
                                {
                                    propInfo.Elevator == 1 ? <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}> <GreenCheckIcon /> آسانسور</Box> : ''
                                }

                                {/* <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}><GreenCheckIcon /> طبقه 3</Box> */}
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                مشخصات اصلی
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <MasahatIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>مساحت : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Space}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <FloorIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تعداد طبقات : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.StoreyCount}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <UsageTypeIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>نوع کاربری : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>مسکونی</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <RoomIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تعداد اتاق : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.RoomsCount}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <ZirbanaIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>زیربنا : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Infrastructure} متر مربع</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <FloorNumIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>طبقه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.StoreyNo && propInfo.StoreyNo == 0 || propInfo.StoreyNo == "0" ? "ندارد" : propInfo.StoreyNo}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>

                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                خصوصیات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    {propInfo.PropertyAge ?
                                        <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            <GreenDotIcon />
                                            <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.PropertyArea}</Typography>
                                        </Grid> : ''}
                                    {
                                        propInfo.Floor ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>کفپوش : </Typography>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Floor}</Typography>
                                            </Grid> : ""
                                    }

                                    {propInfo.KitchenService ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>سرویس آشپزخانه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.KitchenService}</Typography>
                                    </Grid> : ''}
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>حاشیه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.BrinkValue}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>سن بنا : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.PropertyAgeYear}</Typography>
                                    </Grid>
                                    {propInfo.Direction ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>جهت ساختمان : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Direction}</Typography>
                                    </Grid> : ''}
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>نوع سند : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.CertificateType ? propInfo.CertificateType : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>ارتفاع از سقف : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.CeilingHeight ? propInfo.CeilingHeight : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>متراژ کوچه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.PassageWidth ? propInfo.PassageWidth : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تراکم : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Aggregation != "" ? propInfo.Aggregation : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>نما : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Frontage ? propInfo.Frontage : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تعداد واحد در هر طبقه : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.UnitsCount ? propInfo.UnitsCount : '-'}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                امتیازات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>آب : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Water != "" ? propInfo.Water : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>برق : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Electricity != "" ? propInfo.Electricity : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>گاز : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Gas != "" ? propInfo.Gas : '-'}</Typography>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <GreenDotIcon />
                                        <Typography component='span' sx={{ fontSize: '12px' }}>تلفن : </Typography>
                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Landline != "" ? propInfo.Landline : '-'}</Typography>
                                    </Grid>

                                </Grid>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">

                                امکانات
                            </Box>
                            <Box sx={{ p: 2 }}>

                                <Grid container spacing={1}>
                                    {
                                        propInfo.Parking == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>پارکینگ</Typography>
                                            </Grid> : null
                                    }
                                    {
                                        propInfo.Elevator == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>آسانسور</Typography>
                                            </Grid> : ""
                                    }
                                    {
                                        propInfo.Court == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>حیاط</Typography>
                                            </Grid> : ""
                                    }
                                    {
                                        propInfo.Store == 1 ?
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <GreenDotIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>انباری</Typography>
                                            </Grid> : ""
                                    }

                                </Grid>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                دیگر امکانات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {propInfo.Facilities && propInfo.Facilities.length > 0 ?
                                    <Grid container spacing={1}>
                                        {
                                            propInfo.Facilities.map((item, index) => {
                                                if (item in propFacilities) {
                                                    return <Grid item xs={6} key={index} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <GreenDotIcon />
                                                        <Typography component='span' sx={{ fontSize: '12px' }}>{propFacilities[item]}</Typography>
                                                    </Grid>
                                                }



                                            })
                                        }
                                    </Grid> :
                                    <Box sx={{ textAlign: 'center' }}>موردی ثبت نشده!</Box>}
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                برچسب ها
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {/* {labelsLoading ? <Box sx={{ display: "flex", justifyContent: "center" }}><CircularProgress color="inherit" sx={{ width: "20px!important", height: "20px!important" }} /></Box> : labels?.length ? <Grid container spacing={1}>
                                    {labels?.map((item, index) => {
                                        return <Grid key={index} item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            <GreenDotIcon />
                                            <Typography component='span' sx={{ fontSize: '12px' }}>{item?.Text}</Typography>
                                        </Grid>
                                    })}
                                </Grid> : */}
                                <Box sx={{ p: 1, textAlign: "center", width: "100%" }}>موردی یافت نشد!</Box>
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                طبقات
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {propInfo.Floors && propInfo.Floors.length > 0 ?
                                    propInfo.Floors.map((item, index) => {
                                        return [<Box key={index}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <FloorIcon />
                                                <Typography component='span' sx={{ fontSize: '12px' }}>طبقه {item.FloorNo}</Typography>
                                            </Box>
                                            <Grid container spacing={1} key={index} sx={{ mr: "5px", mt: 1 }}>
                                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>زیربنا : {item.Infrastructure}</Typography>
                                                </Grid>
                                                {item.Water && item.Water != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>آب</Typography>
                                                </Grid> : null}
                                                {item.Electricity && item.Electricity != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>برق</Typography>
                                                </Grid> : null}
                                                {item.Gas && item.Gas != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>گاز</Typography>
                                                </Grid> : null}
                                                {item.Phone && item.Phone != "" ? <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>تلفن</Typography>
                                                </Grid> : null}
                                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <GreenDotIcon />
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>تعداد اتاق : </Typography>
                                                    <Typography component='span' sx={{ fontSize: '12px' }}>{item.RoomsCount != "" ? item.RoomsCount : '-'}</Typography>
                                                </Grid>
                                            </Grid>
                                        </Box>]
                                    })

                                    : <Box sx={{ textAlign: 'center' }}>طبقه ای ثبت نشده!</Box>
                                }
                            </Box>
                        </Box>
                        <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                توضیحات عمومی
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {propInfo.PublicDescription}
                            </Box>
                        </Box>
                        {userInfo.Id == propInfo.RegistrarAgency && <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                توضیحات خصوصی
                            </Box>
                            <Box sx={{ p: 2 }}>
                                {propInfo.Description}
                            </Box>
                        </Box>}
                        {userInfo.Id == propInfo.RegistrarAgency && <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2 }}>
                            <Box className="header-dark-blue">
                                مشخصات مالک
                            </Box>
                            <Box sx={{ p: 2 }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'top', gap: '5px' }}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>کد ملک :</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.Row}</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>نام مالک :</Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>{propInfo.FullName}</Typography>
                                            </Grid>
                                            {/* <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>شغل : </Typography>
                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <Typography component='span' sx={{ fontSize: '12px' }}>املاک</Typography>
                                            </Grid> */}
                                            {/* <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>

                                                <Typography component='span' sx={{ fontSize: '12px' }}>تاریخ بازیابی : </Typography>

                                            </Grid>
                                            <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>

                                                <Typography component='span' sx={{ fontSize: '12px' }}>1398/5/9</Typography>

                                            </Grid> */}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', gap: '5px', flexDirection: 'column' }}>
                                        {propInfo?.LandLord && propInfo?.LandLord?.Telephones?.Mobile[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                                            <a href={`tel:${propInfo.LandLord && propInfo.LandLord.Telephones.Mobile[0]?.value}`}>
                                                <MobileIcon />
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px' }}>{propInfo.LandLord && propInfo.LandLord.Telephones.Mobile[0]?.value}</Box>
                                                    <GreenArrow />
                                                </Box>
                                            </a>
                                        </Button>}
                                        {propInfo.LandLord && propInfo.LandLord.Telephones.Mobile[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                                            <a href={`sms:${propInfo.LandLord && propInfo.LandLord.Telephones.Mobile[0]?.value}`}>
                                                <MailIcon />
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px' }}>{propInfo.LandLord && propInfo.LandLord.Telephones.Mobile[0]?.value}</Box>
                                                    <GreenArrow />
                                                </Box>
                                            </a>
                                        </Button>}
                                        {propInfo.LandLord && propInfo.LandLord.Telephones.Tel[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                                            <a href={`tel:${propInfo.LandLord && propInfo.LandLord.Telephones.Tel[0]?.value}`}>

                                                <PhoneIcon />
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <Box className="flex-1" sx={{ color: '#707070', fontSize: '12px' }}>{propInfo.LandLord && propInfo.LandLord.Telephones.Tel[0]?.value}</Box>
                                                    <GreenArrow />
                                                </Box>
                                            </a>
                                        </Button>}
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>}

                        <LabelsList labels={labelsDetails} handleGetLabels={handleGetLabels} handleLabelsModalClick={handleLabelsModalClick} />
                        {archives.length ? <Box>
                            {archives.map((item, index) => {
                                return <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2, p: 2, display: 'flex', flexDirection: "column", gap: "5px" }} key={index}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <Box>تاریخ ثبت : </Box>
                                            <Box>۱۴۰۱/۱۱/۲۶</Box>
                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                            <IconButton onClick={() => handleeditArchiveModal(item.Id)}>
                                                <img src='/assets/img/EditIcon.png' />
                                            </IconButton>
                                            <IconButton onClick={() => handleArchiveDeleteModalClick(item.Id)}>
                                                <img src='/assets/img/DeleteIcon.png' />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                    {item.ContractCancelled == "1" && <Box>مالک منصرف یا منتهی به قراداد نشد.</Box>}
                                    {/* <Box>1401/11/16</Box> */}
                                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <Box>مبلغ کل کمیسیون دریافتی : </Box>
                                        <Box>{parseInt(item.TotalPrice).toLocaleString()}</Box>
                                    </Box>
                                    {item.Users && item.Users.length && <Box className="commUsers-container">
                                        {item.Users.map((user, index) => {
                                            return <Box className="commUser-item" sx={{ display: 'flex', flexDirection: "column", gap: "5px" }}>
                                                <Box>{user.FullName}</Box>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                    <Box>در تاریخ : </Box>
                                                    <Box>۱۴۰۱/۱۱/۲۶</Box>
                                                </Box>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                    <Box>مبلغ : </Box>
                                                    <Box>{parseInt(user.Price).toLocaleString()}</Box>
                                                </Box>
                                            </Box>
                                        })}
                                    </Box>}
                                    {item.HasRentReminder == "1" && <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                        <Box>موعد یادآوری سررسید اجاره : </Box>
                                        <Box direction="rtl">{moment.unix(item.RentReminderDate).format("jYYYY/jMM/jDD")}</Box>
                                    </Box>}
                                </Box>
                            })}
                        </Box> : ""}

                    </Box> : !propInfoLoading ? <Box id="dashboard-content" sx={{ p: 1, textAlign: 'center', p: 1 }}>موردی یافت نشد!</Box> : <Box id="dashboard-content" sx={{ p: 1, textAlign: 'center', p: 1 }}>در حال بارگیری...</Box>}
                </Box>
                <ButtonNavigation />


                <Dialog className="dialog-box"
                    fullScreen
                    open={openMapModal}
                    onClose={handleOpenMapModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب کنید */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleOpenMapModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ mt: 3, color: '#8F8F8F', display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: '15px', height: '100%' }}>
                        <MapContainer center={[propInfo.Latitude && propInfo.Latitude != "" ? propInfo.Latitude : 36.32386694335946, propInfo.Longitude && propInfo.Longitude != "" ? propInfo.Longitude : 59.579383705135136]} zoom={13} scrollWheelZoom={false} className="h-100">
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            <LocationMarker position={[propInfo.Latitude, propInfo.Longitude]} />

                        </MapContainer>

                    </Box>
                </Dialog>
                {openBuyFileModal && <Dialog className="dialog-box"
                    open={openBuyFileModal}
                    onClose={handleOpenBuyFileModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            آیا میخواهید فایل این ملک را خریداری کنید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleOpenBuyFileModalClose}>خیر</Button>
                        <Button onClick={handleBuyFile} autoFocus>
                            {!buyLoading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                        </Button>
                    </DialogActions>
                </Dialog>}

                {archiveDeleteModal && <Dialog className="dialog-box"
                    open={archiveDeleteModal}
                    onClose={handleArchiveDeleteModalClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            آیا میخواهید این بایگانی را حذف کنید؟
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleArchiveDeleteModalClose}>خیر</Button>
                        <Button onClick={handleDeleteArchive} autoFocus>
                            {!archiveDeleteLoading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                        </Button>
                    </DialogActions>
                </Dialog>}

                {ContactModal && <PropertyContactModal ContactModal={ContactModal} handleContactModalClose={handleContactModalClose} propInfo={propInfo} />}


                {editArchiveModal && <Dialog className="dialog-box"
                    fullScreen
                    open={editArchiveModal}
                    onClose={handleeditArchiveModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            {/* <Typography sx={{ mx: 'auto' }} component="div">
                       
                    </Typography> */}
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleeditArchiveModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: "10px", pt: 3, px: 1, color: '#8F8F8F', paddingBottom: '80px' }}>
                        <Box sx={{ borderBottom: "1px solid #B1B1B1", pb: 1 }}>
                            <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox checked={ContractCancelled == "1"} onChange={(e) => {
                                if (e.target.checked)
                                    setContractCancelled(1)
                                else
                                    setContractCancelled(0)
                            }} />} label="مالک منصرف شد یا منتهی به قرارداد نشد" />
                        </Box>
                        <Box>
                            <label className='f-14 text-label'>مبلغ کل کمیسیون دریافتی</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }} >
                                <TextField
                                    label=""
                                    pattern="(\d)+"
                                    value={commissionPrice}
                                    onChange={e => setCommissionPrice(e.target.value)}
                                    name="numberformat"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                />
                            </Box>
                            <Box className='f-13' sx={{ color: '#29A19C' }}>{showCommissionPrice} {showCommissionPrice != "" ? "تومان" : ""}</Box>
                        </Box>
                        {
                            commissionUsers && commissionUsers.map((item, index) => {
                                return <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: "10px", color: '#8F8F8F' }} key={index}>
                                    <Box>
                                        <label className='f-14 text-label'>میزان سهم کاربر</label>
                                        <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal(index, null)} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                            <span>{item.Name}</span>
                                            <ArrowRightIcon className='rotate-180-minus' />
                                        </Box>
                                    </Box>
                                    <Box>
                                        <label className='f-14 text-label'>مبلغ</label>
                                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }} >
                                            <TextField
                                                label=""
                                                pattern="(\d)+"
                                                value={item.Price}
                                                onChange={e => handleSetCommissionPrice(e, index)}
                                                name="numberformat"
                                                id="formatted-numberformat-input"
                                                className='remove-underline dir-ltr'
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom,
                                                }}
                                                variant="standard"
                                            />
                                        </Box>
                                        {/* <Box className='f-13' sx={{ color: '#29A19C' }}>{showCommissionPrice} {showCommissionPrice != "" ? "تومان" : ""}</Box> */}
                                    </Box>
                                </Box>
                            })
                        }
                        <Button className="inputs-container w-100 border-0" onClick={handlePlusUser} sx={{ width: 'auto', my: 1, p: 1, display: 'flex', direction: 'ltr', justifyContent: 'center', gap: "10px", alignItems: 'center', bgcolor: "#F6F6F6" }}>
                            اضافه کردن کاربر
                            <PlusIcon width="13" height="13" />
                        </Button>

                        <Box sx={{ borderTop: "1px solid #B1B1B1", pt: 1 }}>
                            <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox checked={HasRentReminder == "1"} onChange={(e) => {
                                if (e.target.checked)
                                    setHasRentReminder(1)
                                else
                                    setHasRentReminder(0)
                            }} />} label="موعد یادآوری سر رسید اجاره" />
                        </Box>

                        {HasRentReminder == 1 ? <Box>
                            <label className='f-14 text-label'>در تاریخ</label>
                            <Box className={`inputs-container`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>

                                <div className='flex-1 w-chile-100'>
                                    <DatePicker calendar={persian} placeholder="تاریخ ثبت" value={new DateObject({ date: RentReminderDate * 1000 }).convert(persian, persian_en).format()}
                                        locale={persian_fa} onChange={handleCommisDate} />
                                </div>
                                <CalendarIcon />

                            </Box>
                        </Box> : null}
                    </Box>
                    <Button className='green-btn' onClick={handleSetCommissionUsers} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>
                        {
                            !commissionUsersLoading ? "ثبت" : <img src="/assets/img/ladng2.gif" width="40" />
                        }
                    </Button>
                </Dialog>}

                {openUsersModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openUsersModal}
                    onClose={handleOpenUsersModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                کاربران
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleOpenUsersModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                        <Box >
                            <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                                {
                                    Users && Users.length > 0 ?
                                        Users.map((item, index) => (

                                            <Button className="userItem" sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 2 }} onClick={() => isLabelOn ? handleSetUserLabel(item) : handleSetUserArchive(item)} key={index}>
                                                <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>
                                                    <Box sx={{ bgcolor: "#fff", borderRadius: "50%", width: "40px", height: "40px" }}>
                                                    </Box>
                                                    <Typography component="span">{item.username}</Typography>
                                                </Box>
                                                {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                                            </Button>

                                        ))
                                        : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                                }
                                {
                                    UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                                }

                            </Box>
                        </Box>
                    </Box>
                    <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button>
                </Dialog>}

                {openMoreOptionsModal && <Dialog className="dialog-box"
                    fullScreen
                    open={openMoreOptionsModal}
                    onClose={handleMoreOptionsModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                                {/* انتخاب کنید */}
                            </Typography>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleMoreOptionsModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>

                        <Button className="green-outline-btn" onClick={handleLabelsModalClick} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px', border: '0px !important', bgcolor: '#D6ECD2!important' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <LabelsIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>وظایف و نشانه گذاری ها</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        <Button onClick={handleRelationsModalOpen} className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <HouseIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارتباطات</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        {propInfo?.RegistrarUser == getUserToken()?.UserId || getUserToken()?.IsMaster == 1 ? <Button className="green-outline-btn" onClick={handleShareModalOpen} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <ShareIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>اشتراک گذاری</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button> : ""}
                        {CheckPermissions(userInfo, "property_share") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <SendIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button> : ""}
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <CalendarIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>یادآوری</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                        {CheckPermissions(userInfo, "property_edit") ? props.fromFiling ? propInfo.IsBought ? <Button className="green-outline-btn" onClick={() => navigate(`/property_edit/${propInfo.Id}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <PenIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ویرایش</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button> : null : <Button className="green-outline-btn" onClick={() => navigate(`/property_edit/${propInfo.Id}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <PenIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ویرایش</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button> : ""}
                        {CheckPermissions(userInfo, "property_archive") ? <Button className="green-outline-btn" onClick={handleArchiveModal} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <BackUpIcon />
                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>بایگانی</Box>

                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />
                        </Button> : ""}
                        {CheckPermissions(userInfo, "property_delete") ? props.fromFiling ? propInfo.IsBought ? <Button className="green-outline-btn" onClick={handleClickOpenDeletePropModal} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <DelIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>حذف</Box>
                            </Box>
                            {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                        </Button> : null : <Button className="green-outline-btn" onClick={handleClickOpenDeletePropModal} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <DelIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>حذف</Box>
                            </Box>
                            {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                        </Button> : ""}
                        {propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <a href={`sms:${propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value}`}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <MailIcon />

                                    <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال پیام</Box>
                                </Box>
                                <ArrowRightIcon className="rotate-180-minus" />
                            </a>
                        </Button>}
                       
                        <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <RoundArrowsIcon />

                                <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>انطباق سازی</Box>
                            </Box>
                            <ArrowRightIcon className="rotate-180-minus" />

                        </Button>
                    </Box>
                </Dialog>}

                {/* {openLabelsModal && <ModalComponent showModalState={openLabelsModal}
                    handleModalClose={handleLabelsModalClose}
                    modalTitle="نشان گذاری ها"
                    modalSubmitBtn={handleSaveLabels}
                    modalTitleSubmitBtn="ذخیره"
                    hasSpecificParent={true}
                    headerRightBtnFunction={handleNavigateToSettingLabels}
                    modalHeaderRightBtn={true}
                    headerRightBtnClass="rounded-50"
                    headerRightBtnTitle={<SettingDarkGray />}
                // headerRightBtnStyle={{ bgcolor: '#8F8F8F!important', fontSize: '11px', color: '#fff' }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", p: 2 }}>

                        {
                            labels && labels.length > 0 ?
                                labels.map((item, index) => (
                                    <Box sx={{ display: "flex", alignItems: "center" }} key={index}>
                                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                                        <Box sx={{ width: "100%" }} id={`label-${item.Id}`} className={`labels-entity ${item.Id in labelsChecked ? 'label-selected' : ''}`}>
                                            <Box className='border-0 labels-item' sx={{ p: 1, bgcolor: newShade(item.ColorCode, 40) }}>
                                                <Box className="circle-color" sx={{ bgcolor: item.ColorCode }}></Box>
                                                <Box sx={{ flex: "1", textAlign: "center", color: lightOrDark(item.ColorCode) == "light" ? "#5a5a5a!important" : "#fff!important" }}>
                                                    {item.Text}
                                                </Box>
                                            </Box>
                                            {
                                                item.Id in labelsChecked ?
                                                    <Box>
                                                        <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal(null, item.Id)} sx={{ width: 'auto', mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', bgcolor: "#fff" }}>
                                                            <span> {labelsChecked[item.Id] && labelsChecked[item.Id].AgencyName ? `توسط ${labelsChecked[item.Id]?.AgencyName}` : ""}</span>
                                                            <ArrowRightIcon className='rotate-90' />
                                                        </Box>
                                                        <Box sx={{ display: "flex", gap: "5px", alignItems: "center", mt: 1 }}>
                                                            در تاریخ
                                                            <Box className="labelDate">
                                                                <InputBase value={formatJalali(labelsChecked[item.Id].RemindDate)} className='f-14' onClick={() => showPickerHandle(item.Id)} />
                                                                <Picker
                                                                    isOpen={labelsChecked[item.Id][`showPicker${item.Id}`]}
                                                                    config={config}
                                                                    value={labelsChecked[item.Id] && labelsChecked[item.Id].RemindDate ? new Date(labelsChecked[item.Id].RemindDate) : new Date()}
                                                                    initialValue={labelsChecked[item.Id] && labelsChecked[item.Id].RemindDate ? new Date(labelsChecked[item.Id].RemindDate) : new Date()}
                                                                    minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                                                    maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                                                    onSubmit={(date) => LabelReminderDateHandle(date, item.Id)}
                                                                    // onChange={(date) => LabelReminderDateHandle(date, item.Id)}
                                                                    onClose={() => closePickerHandle(item.Id)}
                                                                    highlightWeekends
                                                                />
                                                                <CalendarIcon width="30px" />

                                                            </Box>
                                                            یادآوری شود.
                                                        </Box>
                                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                                            <Checkbox id={`daily-remind${index}`} sx={{ mr: "-10px" }} className='green-check' checked={labelsChecked[item.Id]["DailyReminder"]} onChange={e => handleLabelDailyReminder(e, item.Id)} />
                                                            <label for={`daily-remind${index}`} style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                                                به صورت روزانه تکرار شود تا
                                                                <Box className="labelDate" sx={{ width: "35px!important" }}>
                                                                    <InputBase className='f-14' type="number" sx={{ textAlign: "center!important" }} value={labelsChecked[item.Id]["RepeatDays"]} onChange={e => handleSetRepeatDays(e, item.Id)} />
                                                                </Box>
                                                                روز
                                                            </label>
                                                        </Box>

                                                    </Box>
                                                    : ""
                                            }
                                        </Box>
                                        <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
                                            <Checkbox className='green-check f-16' onChange={e => handleAddEntityLabel(item.Id)} checked={item.Id in labelsChecked} />
                                        </Box>
                                    </Box>
                                ))
                                : !labelsLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                        }
                        {
                            labelsLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                        }


                    </Box>
                </ModalComponent>} */}

                <SetLabelsModal labelsDetails={labelsDetails} handleGetLabels={handleGetLabels} handleMoreOptionsModalClose={handleMoreOptionsModalClose} openLabelsModal={openLabelsModal} handleLabelsModalClose={handleLabelsModalClose} labels={labels} isLabelOn={isLabelOn} Id={propInfo?.Id} />

                {relationsModal && <RelationsModal relationsModal={relationsModal} handleRelationsModalClose={handleRelationsModalClose} propInfo={propInfo} />}

                {archiveModal && <Dialog className="dialog-box"
                    fullScreen
                    open={archiveModal}
                    onClose={handleArchiveModalClose}
                    TransitionComponent={Transition}
                >
                    <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                        <Toolbar>

                            {/* <Typography sx={{ mx: 'auto' }} component="div">
                       
                    </Typography> */}
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleArchiveModalClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: "10px", pt: 3, px: 1, color: '#8F8F8F', paddingBottom: '80px' }}>
                        <Box sx={{ borderBottom: "1px solid #B1B1B1", pb: 1 }}>
                            <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                if (e.target.checked)
                                    setContractCancelled(1)
                                else
                                    setContractCancelled(0)
                            }} />} label="مالک منصرف شد یا منتهی به قرارداد نشد" />
                        </Box>
                        <Box>
                            <label className='f-14 text-label'>مبلغ کل کمیسیون دریافتی</label>
                            <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }} >

                                <TextField
                                    label=""
                                    pattern="(\d)+"
                                    value={commissionPrice}
                                    onChange={e => setCommissionPrice(e.target.value)}
                                    name="numberformat"
                                    id="formatted-numberformat-input"
                                    className='remove-underline dir-ltr'
                                    InputProps={{
                                        inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                />
                            </Box>
                            <Box className='f-13' sx={{ color: '#29A19C' }}>{showCommissionPrice} {showCommissionPrice != "" ? "تومان" : ""}</Box>
                        </Box>
                        {
                            commissionUsers && commissionUsers.map((item, index) => {
                                return <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: "10px", color: '#8F8F8F' }} key={index}>
                                    <Box>
                                        <label className='f-14 text-label'>میزان سهم کاربر</label>
                                        <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal(index, null)} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                            <span>{item.Name}</span>
                                            <ArrowRightIcon className='rotate-180-minus' />
                                        </Box>
                                    </Box>
                                    <Box>
                                        <label className='f-14 text-label'>مبلغ</label>
                                        <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }} >
                                            <TextField
                                                label=""
                                                pattern="(\d)+"
                                                value={item.Price}
                                                onChange={e => handleSetCommissionPrice(e, index)}
                                                name="numberformat"
                                                id="formatted-numberformat-input"
                                                className='remove-underline dir-ltr'
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom,
                                                }}
                                                variant="standard"
                                            />
                                        </Box>
                                        {/* <Box className='f-13' sx={{ color: '#29A19C' }}>{showCommissionPrice} {showCommissionPrice != "" ? "تومان" : ""}</Box> */}
                                    </Box>
                                </Box>
                            })
                        }
                        <Button className="inputs-container w-100 border-0" onClick={handlePlusUser} sx={{ width: 'auto', my: 1, p: 1, display: 'flex', direction: 'ltr', justifyContent: 'center', gap: "10px", alignItems: 'center', bgcolor: "#F6F6F6" }}>
                            اضافه کردن کاربر
                            <PlusIcon width="13" height="13" />
                        </Button>

                        <Box sx={{ borderTop: "1px solid #B1B1B1", pt: 1 }}>
                            <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                                if (e.target.checked)
                                    setHasRentReminder(1)
                                else
                                    setHasRentReminder(0)
                            }} />} label="موعد یادآوری سر رسید اجاره" />
                        </Box>

                        {HasRentReminder == 1 ? <Box>
                            <label className='f-14 text-label'>در تاریخ</label>
                            <Box className={`inputs-container`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>

                                <div className='flex-1 w-chile-100'>
                                    {/* <DatePicker calendar={persian} placeholder="تاریخ ثبت"
                                locale={persian_fa} onChange={handleCommisDate} /> */}
                                    <InputBase placeholder="تاریخ ثبت" value={formatJalali(RentReminderDate)} className='flex-1' onClick={() => setShowPicker(true)} />
                                    <Picker
                                        isOpen={showPicker}
                                        config={config}
                                        value={state.RegisterDate}
                                        initialValue={new Date(RentReminderDate ? new Date(RentReminderDate) : new Date())}
                                        minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                        maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                        onSubmit={handleCommisDate}
                                        // onChange={handleCommisDate}
                                        onClose={() => setShowPicker(false)}
                                        highlightWeekends
                                    />
                                </div>
                                <CalendarIcon />

                            </Box>
                        </Box> : null}
                    </Box>
                    <Button className='green-btn' onClick={handleSetCommissionUsers} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>
                        {
                            !commissionUsersLoading ? "ثبت" : <img src="/assets/img/ladng2.gif" width="40" />
                        }
                    </Button>
                </Dialog>}

                {uploadImagesLoading && <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={uploadImagesLoading}
                    onClose={handleUploadImagesLoadingClose}
                    // TransitionComponent={state.Transition}
                    message="در حال بارگذاری تصاویر..."

                />}
            </Box> : !openBackdrop ? <Box id="dashboard-content" sx={{ p: 5, textAlign: 'center' }}>موردی یافت نشد!</Box> : ""}


            {showShareModal && <ShareModalCompo handleShareModalClose={handleShareModalClose} showShareModal={showShareModal} propId={propInfo?.Id} />}

            {deletePropModal && <Dialog className="dialog-box"
                open={deletePropModal}
                onClose={handleDeletePropModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        آیا میخواهید این ملک را حذف کنید؟
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeletePropModalClose}>خیر</Button>
                    <Button onClick={handleDelete} autoFocus>
                        {!deleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                    </Button>
                </DialogActions>
            </Dialog>}

        </Box>
    );
}

export default PropertyDetails